import { IArea } from "../area/response";
import { ITranslationRequest } from "../base/translation";
import { Status } from "../client/enum";
import { OrderLimitType } from "./enum";
export interface ICreateDiscountCode {
  name: ITranslationRequest;
  code: string;
  validityDate: string;
  codeValidity: number;
  numberPoints: number;
  maxOfUse: number;
  status: number;
  type: number;
  invitationType: number;
  imageId: number;
  notifyImageId: number;
  note: ITranslationRequest;
  showInApp: boolean;
  typeApp: number;
  isInvitation: boolean;

  typeValue: number;
  minimumLimit: number;
  tagIds: number[];

  upperLimit: number;
  valueOfAllDiscountCodes: number;

  companyId: number;
  specialStoreId: number;
  sponsorType: number;

  numberOfUseAllowed: number;
  discountValueProduct: number;
  discountValueDelivery: number;
  canBePurchased: boolean;

  message: string;
  minAge: number;
  maxAge: number;
  userType: number;
  minNumberOfOrders: number;
  maxNumberOfOrders: number;

  minDaysSinceLastCompletedOrder: number;
  maxDaysSinceLastCompletedOrder: number;

  enableAgeRange?: boolean;

  gender?: Status;
  enableGender?: boolean;

  areaId?: number;
  enableArea?: boolean;

  enableNumberOfOrders?: boolean;
  enableDaysSinceLastCompletedOrder?: boolean;
  orderLimitType?: OrderLimitType;
  exactNumberOfOrders?: number;
  daysLimitType?: OrderLimitType;
  exactDaysSinceLastCompletedOrder?: number
}

export interface ICreateDiscountCodeClients {
  clientId?: number;
  areaId?: number; 
  discountCodeId: number;
  type?: string; 
}

export interface ISendNotificationDiscountCodeClients {
  message?: string
}

export interface IUpdateDiscountCode extends ICreateDiscountCode { }

export interface IExportDiscountCodeExcel {
  code: boolean;
  status: boolean;
  type: boolean;
  discountValueProduct: boolean;
  discountValueDelivery: boolean;
  validityDate: boolean;
  codeValidity: boolean;
  numberPoints: boolean;
  maxOfUse: boolean;
  frequencyOfUse: boolean;
  id: boolean;
  typeDiscountCode: boolean;
  typeValueDiscountCode: boolean;
  upperLimit: boolean;
  valueOfAllDiscountCodes: boolean;

  minimumLimit: boolean;

}

export const colomnsExportDiscountCodeExcel = [
  "id",
  "code",
  "status",
  "type",
  "discountValueProduct",
  "discountValueDelivery",
  "validityDate",
  "codeValidity",
  "numberPoints",
  "maxOfUse",
  "frequencyOfUse",
  "typeDiscountCode",
  "typeValueDiscountCode",
  "upperLimit",
  "valueOfAllDiscountCodes",

  "minimumLimit",
];
